import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { LayoutsModule } from './layouts/layouts.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { isNewAuthFlowEnabled } from './core/auth-flow/is-new-auth-flow';
import { AUTH_SESSION, LOGIN_FLOW } from './core/auth-flow/tokens';
import { LegacyAuthSessionService } from './core/auth-flow/legacy/legacy-auth-session.service';
import { LegacyJwtInterceptor } from './core/auth-flow/legacy/legacy-jwt.interceptor';
import { LegacyLoginService } from './core/auth-flow/legacy/legacy-login.service';
import { NewAuthSessionService } from './core/auth-flow/new/new-auth-session.service';
import { NewJwtInterceptor } from './core/auth-flow/new/new-jwt.interceptor';
import { NewLoginService } from './core/auth-flow/new/new-login.service';
import { L10nIntlModule, L10nTranslationModule } from 'angular-l10n';
import { l10nConfig } from './l10n-config';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '@base/environments/environment';
import { ROOT_REDUCERS } from './store/app.state';
import { EffectsModule } from '@ngrx/effects';
import { MatSelectModule } from '@angular/material/select';
import { DatePipe, DecimalPipe } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { getTenantLocaleId, registerTenantLocale } from './locales/locale-config';

registerTenantLocale();

declare global {
  interface Navigator {
    msSaveBlob: (blob: Blob, fileName: string) => boolean;
  }
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    MatProgressSpinnerModule,
    LeafletModule,
    MatSelectModule,
    HttpClientModule,
    LayoutsModule,
    AppRoutingModule,
    L10nTranslationModule.forRoot(l10nConfig),
    L10nIntlModule,
    StoreModule.forRoot(ROOT_REDUCERS),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
    EffectsModule.forRoot([]),
  ],
  exports: [],
  providers: [
    ...(isNewAuthFlowEnabled()
      ? [
          NewLoginService,
          NewAuthSessionService,
          { provide: LOGIN_FLOW, useExisting: NewLoginService },
          { provide: AUTH_SESSION, useExisting: NewAuthSessionService },
          {
            provide: HTTP_INTERCEPTORS,
            useClass: NewJwtInterceptor,
            multi: true,
          },
        ]
      : [
          LegacyLoginService,
          LegacyAuthSessionService,
          { provide: LOGIN_FLOW, useExisting: LegacyLoginService },
          { provide: AUTH_SESSION, useExisting: LegacyAuthSessionService },
          {
            provide: HTTP_INTERCEPTORS,
            useClass: LegacyJwtInterceptor,
            multi: true,
          },
        ]),
    DecimalPipe,
    CookieService,
    DatePipe,
    {
      provide: LOCALE_ID,
      useValue: getTenantLocaleId(),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
